var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "MediumEditor u-InputMarginView",
      class: [
        _vm.modes.map((m) => `MediumEditor--${m}`),
        { "MediumEditor--error": _vm.isError && _vm.required },
      ],
    },
    [
      _vm.required
        ? _c("span", { staticClass: "MediumEditorViewRequired" }, [_vm._v("*")])
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c(
            "label",
            {
              staticClass: "MediumEditorLabel",
              attrs: { for: `MediumEditor-input-${_vm._uid}` },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("p", [_vm._v("Встроенный редактор")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("editor", {
        staticClass: "MediumEditorInput",
        style: {
          minHeight: _vm.minHeight,
          maxWidth: _vm.maxWidth,
          minWidth: _vm.minWidth,
          height: _vm.height,
        },
        attrs: {
          id: `MediumEditor-input-${_vm._uid}`,
          text: _vm.innerValue,
          options: _vm.options,
          placeholder: _vm.placeholder,
        },
        on: { edit: _vm.checkChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }